import { Box, Typography } from "@mui/material";
import { addDays, format } from "date-fns";
import MuiDatePicker, {
  MuiTimePicker,
} from "../../../components/ui/DateAndTimePicker";
import React from "react";
import { useTranslation } from "react-i18next";

export const DateTimeSection = ({
  title,
  disabled = false,
  formik,
  dateField,
  timeField,
  showNextAvailable = false,
  isLocalAuction = false,
}) => {

  const { t } = useTranslation("carEstimateAuction");

  // useState variables start...
  const [minTimeForPicker, setMinTimeForPicker] = React.useState(null);
  // useState variables end...

  // Function to get the next available day (Monday, Wednesday, or Friday)
  const getNextAvailableDate = () => {
    const today = new Date();
    const day = today.getDay(); // 0 (Sunday) to 6 (Saturday)

    // Calculate days until next available day
    let daysToAdd;
    if (day <= 1) daysToAdd = 1 - day; // Monday (1)
    else if (day <= 3) daysToAdd = 3 - day; // Wednesday (3)
    else if (day <= 5) daysToAdd = 5 - day; // Friday (5)
    else daysToAdd = 8 - day; // Next Monday (1 + 7 - day)

    console.log(daysToAdd, day, `daysToAdd`)

    // If daysToAdd is 0 (it's already an available day), move to next available
    // if (daysToAdd === 0) {
    //   if (day === 1) daysToAdd = 2; // Monday -> Wednesday
    //   else if (day === 3) daysToAdd = 2; // Wednesday -> Friday
    //   else daysToAdd = 3; // Friday -> Monday
    // }

    const nextDate = addDays(today, daysToAdd);
    return format(nextDate, "EEEE, MMMM d");
  };

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date();
      const minTimeForPicker = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes(),
        0
      );

      setMinTimeForPicker(minTimeForPicker);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    }
  }, []);

  return (
    <Box p={2} px={2.5}>
      <Box display={"flex"} gap={2} justifyContent={"space-between"}>
        <Typography color="text.form">{title}</Typography>
        {showNextAvailable && (
          <Typography color="red">
            {t("dateTimeSection.Next Available Date")}:{" "}
            <Typography component={"span"}>{getNextAvailableDate()}</Typography>
          </Typography>
        )}
      </Box>

      <Box display={"flex"} gap={2} mt={3}>
        <Box display={"flex"} gap={2} alignItems={"center"}>
          <Typography color="text.form">Date:</Typography>
          <MuiDatePicker
            label="MM-DD-YYYY"
            disabled={disabled}
            disablePast
            value={formik.values[dateField]}
            onChange={(value) => formik.setFieldValue(dateField, value)}
            error={
              formik.touched[dateField] && Boolean(formik.errors[dateField])
            }
            helperText={formik.touched[dateField] && formik.errors[dateField]}
            isLocalAuction={isLocalAuction}
          />
        </Box>
        <Box display={"flex"} gap={2} alignItems={"center"}>
          <Typography color="text.form">Time:</Typography>
          <MuiTimePicker
            label="hh:mm"
            disabled={disabled}
            // disablePast
            value={formik?.values[timeField]}
            // value={formik.values[timeField] && formik.values[timeField].getTime() >= minTimeForPicker?.getTime() ? formik.values[timeField] : minTimeForPicker}
            // minTime={minTimeForPicker}
            onChange={(value) => formik.setFieldValue(timeField, value)}
            error={
              formik.touched[timeField] && Boolean(formik.errors[timeField])
            }
            helperText={formik.touched[timeField] && formik.errors[timeField]}
          />
        </Box>
      </Box>
    </Box>
  );
};
